(() => {
  'use strict';
  const button = document.querySelector('[data-back-to-top]');
  if (!button) return;
  const downButton = document.querySelector('[data-scroll-down]');

  const homepage = document.body.classList.contains('objectiv-homepage');
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let firstSection, secondSection, stickyBar, threshold = window.innerHeight, heroStart = 0;
  let frame = 0, needsMeasure = true;

  // Cache geometry on resize; scrolling only checks the cached threshold.
  const queue = (measure = false) => {
    needsMeasure ||= measure;
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      if (needsMeasure) {
        const rect = firstSection?.getBoundingClientRect(), y = window.ObjectivScroll?.y ?? window.scrollY;
        threshold = rect ? rect.bottom + y : window.innerHeight;
        heroStart = rect ? rect.top + y : 0;
        if (stickyBar) button.style.setProperty('--obj-back-to-top-clearance', `${stickyBar.offsetHeight}px`);
        needsMeasure = false;
      }
      button.hidden = (window.ObjectivScroll?.y ?? window.scrollY) < threshold || threshold <= 0;
      if (downButton) {
        const y = window.ObjectivScroll?.y ?? window.scrollY;
        // Clear the fixed hero cue before it can cover the incoming bottle/copy.
        const cueOpacity = homepage ? Math.max(0, Math.min(1, 1 - (y - heroStart) / Math.max(1, (threshold - heroStart) * .15))) : 1;
        downButton.style.opacity = String(motion.matches && cueOpacity < 1 ? 0 : cueOpacity);
        downButton.hidden = !secondSection || y >= threshold || threshold <= 0 || (homepage && (motion.matches ? cueOpacity < 1 : cueOpacity === 0));
      }
    });
  };

  const observer = new ResizeObserver(() => queue(true));
  const bindSections = () => {
    observer.disconnect();
    const main = document.getElementById('MainContent');
    const aboutHero = main?.querySelector('[data-about-video-hero]');
    firstSection = homepage ? main?.querySelector(':scope > .shopify-section') || main?.querySelector('[data-objectiv-logo-hero]') || main?.firstElementChild : aboutHero;
    secondSection = homepage ? main?.querySelector('.obj-scrolly-section') : aboutHero ? main?.querySelector('[data-about-intro]') : null;
    stickyBar = document.querySelector('.js-obj-sticky-bar');
    if (firstSection) observer.observe(firstSection);
    if (stickyBar) observer.observe(stickyBar);
    queue(true);
  };

  button.addEventListener('click', event => {
    // Give keyboard users a useful focus destination when this button hides.
    if (event.detail === 0) document.getElementById('MainContent')?.focus({ preventScroll: true });
    (window.ObjectivScroll || window).scrollTo({ top: 0, behavior: motion.matches ? 'instant' : 'smooth' });
  });
  window.addEventListener(window.ObjectivScroll ? 'objectiv:scroll' : 'scroll', () => queue(), { passive: true });
  downButton?.addEventListener('click', event => {
    if (!secondSection) return;
    if (event.detail === 0) {
      if (!secondSection.hasAttribute('tabindex')) secondSection.setAttribute('tabindex', '-1');
      secondSection.focus({ preventScroll: true });
    }
    (window.ObjectivScroll || window).scrollTo({ top: secondSection.getBoundingClientRect().top + (window.ObjectivScroll?.y ?? window.scrollY), behavior: motion.matches ? 'instant' : 'smooth' });
  });
  window.addEventListener('resize', () => queue(true), { passive: true });
  window.addEventListener('pageshow', () => queue(true));
  window.addEventListener('load', () => queue(true), { once: true });
  document.addEventListener('shopify:section:load', bindSections);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(bindSections));
  document.fonts?.ready.then(() => queue(true));
  bindSections();
})();
